<template>
  <div>
    <div v-if="Object.keys(archives).length > 0">
      <div class="col-md-12 row pb-10 pt-2">
        <div class="col-md text-right">
          <div class="col-md-8 mx-auto mb-4" v-if="archives.file">
            <v-carousel
              :continuous="true"
              :show-arrows="archives.file.length > 1"
              height="300"
              hide-delimiter-background
              hide-delimiters
            >
              <v-carousel-item
                v-for="item in archives.file"
                :src="imageFiles(item)"
                contain
              ></v-carousel-item>
            </v-carousel>
          </div>
          <div class="row mx-auto px-0">
            <p class="col-md-4 py-1">
              <span class="font-weight-bolder" style="color: darkblue"
                >نام مجموعه :</span
              >
              {{ archives.name }}
            </p>
            <p class="col-md-4 py-1">
              <span class="font-weight-bolder" style="color: darkblue"
                >نام دامنه :</span
              >
              {{ archives.domain }}
            </p>
            <p class="col-md-4 py-1">
              <span class="font-weight-bolder" style="color: darkblue"
                >زبان برنامه نویسی :</span
              >
              {{ archives.programming_language }}
            </p>
            <p v-if="archives.quality" class="col-md-4 py-1">
              <span class="font-weight-bolder" style="color: darkblue"
                >کیفیت سایت :</span
              >
              {{ quality[archives.quality] }}
            </p>
            <p v-if="archives.site_type" class="col-md-4 py-1">
              <span class="font-weight-bolder" style="color: darkblue"
                >نوع سایت :</span
              >
              {{ siteType[archives.site_type] }}
            </p>
            <p v-if="archives.seo_type" class="col-md-4 py-1">
              <span class="font-weight-bolder" style="color: darkblue"
                >نوع سئو :</span
              >
              {{ seoType[archives.seo_type] }}
            </p>
            <p v-if="archives.key_words" class="col-md-4 py-1">
              <span class="font-weight-bolder" style="color: darkblue"
                >کلمات کلیدی :</span
              >
              <span v-for="item in archives.key_words"> {{ item }} , </span>
            </p>
            <p class="col-md-4 py-1">
              <span class="font-weight-bolder" style="color: darkblue"
                >تعداد ماه های پشتیبانی :</span
              >
              {{ archives.support_time }}
            </p>
            <p class="col-md-4 py-1">
              <span class="font-weight-bolder" style="color: darkblue"
                >تعداد مقاله ها :</span
              >
              {{ archives.article_count }}
            </p>
            <p class="col-md-4 py-1">
              <span class="font-weight-bolder" style="color: darkblue"
                >تعداد محصولات درخواستی :</span
              >
              {{ archives.data_by }}
            </p>
            <p class="col-md-4 py-1">
              <span class="font-weight-bolder" style="color: darkblue"
                >نوع سفارش :</span
              >
              {{ orderType[archives.type] }}
            </p>
            <p v-if="archives.user_price" class="col-md-4 py-1">
              <span class="font-weight-bolder" style="color: darkblue"
                >قیمت پیشنهادی کاربر :</span
              >
              {{ archives.user_price | currency | persianNum }}
              {{ archives.preferred_currency === "Rial" ? "﷼" : "تومان" }}
            </p>
            <div class="col-md-4 pt-1">
              <p>
                <span class="font-weight-bolder" style="color: darkblue"
                  >سایت های پیشنهادی :</span
                >
              </p>
              <ol v-for="item in archives.recommended_sites">
                <li style="">
                  نام سایت :
                  <a :href="urlSet(item.key)" target="_blank">{{ item.key }} </a
                  ><br />
                  <span> توضیحات : {{ item.value }}</span>
                </li>
              </ol>
            </div>

            <div class="col-md-4 pt-1">
              <p>
                <span class="font-weight-bolder" style="color: darkblue"
                  >منو های پیشنهادی :</span
                >
              </p>
              <ol v-for="item in archives.menu">
                <li style="">
                  نام منو :
                  <p>{{ item.key }}</p>
                  <br />
                  <span> توضیحات : {{ item.value }}</span>
                </li>
              </ol>
            </div>

            <div class="col-md-4 pt-1">
              <p>
                <span class="font-weight-bolder" style="color: darkblue"
                  >سایت های رقبا :</span
                >
              </p>
              <ol v-for="item in archives.rivals">
                <li class="mr-3">
                  نام سایت :
                  <a :href="urlSet(item.key)" target="_blank"
                    >{{ urlSet(item.key) }} </a
                  ><br />
                  <span> توضیحات : {{ item.value }}</span>
                </li>
              </ol>
            </div>

            <div v-if="archives.description !== null">
              <p class="pr-3 pt-2">
                <span class="font-weight-bolder" style="color: darkblue"
                  >توضیحات :
                </span>
              </p>

              <p
                class="font-weight-bold py-0 col-md pr-3"
                v-for="line in archives.description.split('\n')"
                :key="line"
                v-html="line"
              ></p>
            </div>
            <div v-if="archives.reject_text !== null">
              <p class="pr-3 pt-2">
                <span class="font-weight-bolder" style="color: darkblue"
                  >دلیل رد کردن :
                </span>
              </p>

              <p
                class="font-weight-bold py-0 col-md pr-3"
                v-for="line in archives.reject_text.split('\n')"
                :key="line"
                v-html="line"
              ></p>
            </div>
          </div>
          <template v-if="admin">
            <v-container class="px-0" fluid>
              <v-radio-group v-model="status">
                <v-radio
                  color="indigo"
                  label="پذیرش درخواست"
                  value="accept"
                ></v-radio>
                <div v-if="status === 'accept'">
                  <template>
                    <v-sheet width="100%">
                      <v-switch
                        v-model="installment"
                        flat
                        label="پرداخت قسطی"
                      ></v-switch>
                      <div v-if="installment">
                        <v-row v-if="installment">
                          <v-col class="text-right" cols="12" md="6">
                            <v-text-field
                              outlined
                              label="مبلغ کل"
                              dense
                              v-model="main_price"
                              clearable
                              type="text"
                              suffix="﷼"
                              @keypress="allowOnlyNumbers"
                              clear-icon="mdi-close-circle"
                              prepend-inner-icon="fa fa-pencil-alt"
                            ></v-text-field>
                          </v-col>
                          <v-col class="text-right" cols="12" md="6">
                            <v-text-field
                              outlined
                              label="تعداد اقساط"
                              dense
                              v-model="count"
                              clearable
                              @keypress="allowOnlyNumbers"
                              clear-icon="mdi-close-circle"
                              prepend-inner-icon="fa fa-pencil-alt"
                            ></v-text-field>
                          </v-col>
                          <v-col class="text-right" cols="12" md="6">
                            <v-textarea
                              outlined
                              dense
                              v-model="Acceptdescription"
                              clearable
                              clear-icon="mdi-close-circle"
                              prepend-inner-icon="fa fa-pencil-alt"
                              label="توضیحات قسط"
                              rows="5"
                            ></v-textarea>
                          </v-col>
                          <v-col class="text-right" cols="12" md="6">
                            <date-picker
                              v-model="days"
                              multiple
                              color="#00acc1"
                              label="تاریخ پرداخت"
                              input-class="mb-0 rounded"
                              persianDigits
                              clearable
                              :timezone="false"
                              format="YYYY-MM-DD"
                              style="font-size: 13px !important"
                              class="dateSet"
                              display-format="jMMMM jD"
                            />
                          </v-col>
                          <v-row class="px-5 mb-8">
                            <v-col
                              v-for="(item, index) in transactions"
                              class="text-right"
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                outlined
                                label="مبلغ قسط"
                                dense
                                clearable
                                :value="transactions[index].price | currency"
                                @input="priceIs(transactions[index], $event)"
                                @keypress="allowOnlyNumbers"
                                clear-icon="mdi-close-circle"
                                prepend-inner-icon="fa fa-pencil-alt"
                              >
                                <template v-slot:append>
                                  <v-chip
                                    close
                                    close-icon="mdi-delete"
                                    color="indigo"
                                    @click:close="removeDay(index)"
                                    dense
                                    small
                                    outlined
                                    pill
                                    >{{
                                      jalalian(transactions[index].expired_at)
                                    }}
                                  </v-chip>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-row>
                        <div class="text-center">
                          <p>
                            مبلغ قابل پرداخت در هر قسط :
                            <span class="text-primary"
                              >{{ countPrice | currency | persianNum }} ﷼
                            </span>
                          </p>
                        </div>
                      </div>
                      <v-switch
                        v-model="final"
                        flat
                        label="پرداخت بصورت یکجا"
                      ></v-switch>
                      <div v-if="final">
                        <v-row v-if="final">
                          <v-col class="text-right" cols="12" md="6">
                            <v-text-field
                              outlined
                              label="مبلغ کل"
                              dense
                              v-model="main_price"
                              clearable
                              suffix="﷼"
                              @keypress="allowOnlyNumbers"
                              clear-icon="mdi-close-circle"
                              prepend-inner-icon="fa fa-pencil-alt"
                            ></v-text-field>
                          </v-col>
                          <v-col class="text-right" cols="12" md="6">
                            <v-textarea
                              outlined
                              dense
                              v-model="Acceptdescription"
                              clearable
                              clear-icon="mdi-close-circle"
                              prepend-inner-icon="fa fa-pencil-alt"
                              label="توضیحات قسط"
                              rows="5"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </div>
                    </v-sheet>
                  </template>
                </div>
                <v-radio
                  color="indigo"
                  label="ردکردن درخواست"
                  value="reject"
                ></v-radio>
                <div v-if="status === 'reject'">
                  <v-textarea
                    outlined
                    dense
                    v-model="Rejectdescription"
                    clearable
                    clear-icon="mdi-close-circle"
                    prepend-inner-icon="fa fa-pencil-alt"
                    label="دلیل رد کردن"
                    rows="5"
                  ></v-textarea>
                </div>
              </v-radio-group>
            </v-container>
          </template>
          <div v-if="admin" class="float-left">
            <v-btn
              v-if="installment"
              @click="payInstallment"
              class="submit-btn"
            >
              <span class="fa fa-save ml-1" style="font-size: 1.5rem"></span>
              ثبت درخواست
            </v-btn>

            <v-btn v-if="final" @click="payFinal" class="submit-btn">
              <span class="fa fa-save ml-1" style="font-size: 1.5rem"></span>
              ثبت درخواست
            </v-btn>
            <v-btn
              v-if="status === 'reject'"
              @click="reject"
              class="submit-btn"
            >
              <span class="fa fa-save ml-1" style="font-size: 1.5rem"></span>
              ثبت درخواست
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 py-10 mx-auto" v-else>
      <p class="text-center">در حال بارگیری اطلاعات</p>
      <v-progress-linear
        indeterminate
        height="5"
        striped
        color="indigo"
      ></v-progress-linear>
    </div>
  </div>
</template>

<script>
import { ir } from "../../../check_domain_ir";
export default {
  name: "informations",
  props: {
    id: {
      default: "",
    },
    admin: {
      default: true,
    },
    modal: {
      default: () => {},
      type: Function,
    },
    reqAgain: {
      default: () => {},
      type: Function,
    },
  },
  data() {
    return {
      quality: {
        high: "سایت حرفه ای با کیفیت بالا",
        good: "کیفیت خوب و قابل قبول",
        normal: "کیفیت عادی",
        least: "حداقل موارد مورد نیاز فقط رعایت شود.",
      },
      siteType: {
        personal: "سایت شخصی",
        corporative: "سایت شرکتی",
        shop: "سایت فروشکاهی",
        charity: "سایت موسسه خیریه",
        news: "سایت خبری",
        download: "سایت دانلود",
      },
      orderType: {
        design: "طراحی سایت",
        support: "پشتیبانی سایت",
        seo: "سئو سایت",
      },
      seoType: {
        basic: "پایه",
        branding: "برندینگ",
        professional: "حرفه ای",
        internal: "داخلی",
        external: "خارجی",
        technical: "تکنیکال",
        Contentـproduction: "تولید محتوا",
      },
      archives: {},
      loading: false,
      status: "accept",
      Acceptdescription: [],
      installment: false,
      final: false,
      mainPrice: "",
      transactions: [],
      Rejectdescription: "",
      finalPrice: "",
      days: [],
      description: "",
      count: "",
    };
  },
  methods: {
    imageFiles(item) {
      return this.$appApiUrl + "/storage/" + item;
    },
    getArchives() {
      this.loading = true;
      this.requestApiGet(`admin/form/site/${this.id}`).then((response) => {
        this.loading = false;
        this.archives = response.data;
      });
    },
    payFinal() {
      this.requestApiPost("admin/form/site", {
        type: "final",
        id: this.id,
        name: this.archives.name,
        description:
          this.Acceptdescription !== ""
            ? this.Acceptdescription
            : "پرداخت بصورت یکجا",
        status: "accept",
        price: this.mainPrice,
      }).then(() => {
        this.$toast.success("درخواست شما با موفقیت ثبت شد.");
        this.modal();
        this.reqAgain();
      });
    },
    reject() {
      this.requestApiPost("admin/form/site", {
        type: "final",
        id: this.id,
        name: this.archives.name,
        status: "reject",
        reject_text: this.Rejectdescription,
      }).then(() => {
        this.$toast.success("درخواست شما با موفقیت ثبت شد.");
        this.modal();
        this.reqAgain();
      });
    },
    payInstallment() {
      let sum = 0;
      this.transactions.forEach((item) => {
        sum += Number(item.price);
      });

      if (sum > this.mainPrice) {
        this.$toast.error("مبلغ اقساط وارد شده بیشتر از مبلغ کل می باشد!");
      } else if (sum < this.mainPrice) {
        this.$toast.error("مبلغ اقساط وارد شده کمتر از مبلغ کل می باشد!");
      } else
        this.requestApiPost("admin/form/site", {
          type: "installment",
          id: this.id,
          name: this.archives.name,
          description:
            this.Acceptdescription !== "" ? this.Acceptdescription : "",
          expired_at: "",
          status: "accept",
          price: this.mainPrice,
          transactions: this.transactions,
        }).then(() => {
          this.$toast.success("درخواست شما با موفقیت ثبت شد.");
          this.modal();
          this.reqAgain();
        });
    },
    priceIs(transaction, value) {
      this.transactions[this.transactions.indexOf(transaction)].price = Number(
        value.replaceAll(",", "")
      );
    },
    removeDay(id) {
      this.days.splice(id, 1);
    },
    urlSet(item) {
      return item.indexOf("http") > -1 ? item : `http://${item}`;
    },
  },
  beforeMount() {
    this.getArchives();
  },
  watch: {
    installment(val) {
      if (val) {
        this.final = false;
      } else {
        this.mainPrice = "";
        this.count = "";
        this.Acceptdescription = "";
        this.days = [];
      }
    },
    final(val) {
      if (val) this.installment = false;
    },
    status(val) {
      if (val === "accept") this.description = "";
    },
    days(val) {
      this.count = val.length;
      this.transactions = [];
      val.forEach((item, index) => {
        this.transactions.push({
          description: "قسط" + " " + Number(index + 1),
          price: "",
          expired_at: item,
        });
      });
    },
    finalPrice(val) {
      this.transactions = [];
      this.days.forEach((item, index) => {
        this.transactions.push({
          description: "قسط" + " " + Number(index + 1),
          price: "",
          expired_at: item,
        });
      });
    },
  },
  computed: {
    main_price: {
      get() {
        return this.$options.filters.currency(this.mainPrice);
      },
      set(value) {
        this.mainPrice = value.replaceAll(",", "");
      },
    },
    countPrice() {
      return (this.finalPrice = this.mainPrice / this.count);
    },
  },
};
</script>

<style></style>
